<template>
  <div v-if="haveBooking">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Duplicate Booking</h1>
      </div>
    </div>

    <booking-duplicate-form
      :booking="booking"
      :set-booking-action="setBooking"
      :set-booking-property-mutator="setBookingProperty">
      <span slot="button">Submit Request</span>
    </booking-duplicate-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { helpers } from 'mixins/bookings'
import BookingDuplicateForm from 'components/booking/BookingDuplicateForm'

export default {
  props: ['id'],

  mixins: [helpers],

  components: {
    BookingDuplicateForm
  },

  computed: {
    ...mapState('booking', ['booking']),
    ...mapGetters('booking', ['haveBooking'])
  },

  created () {
    this.getBookingForDuplicate({ id: this.id })
      .catch((error) => {
        this.handleCaughtHttpExceptionForBooking(error, 'The booking could not be found.')
      })
  },

  methods: {
    ...mapActions('booking', ['getBookingForDuplicate', 'setBooking', 'setBookingProperty'])
  }
}
</script>
